import React,{useState,useEffect} from "react";
import CustomListBrands from './customListBrands';
import CustomFlags from "../sharedComponents/customFlags";
import CustomBlackButton  from '../sharedComponents/customBlackButton';
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
const CustomShoppngCardDetials = ({ image, title, imageTitle, subTitle, children, onClick, icon: Icon ,area }) => {
  const {t} = useTranslation();
  const direction = useLanguageDirection();

        
   return (
    <div className="flex flex-col items-center justify-center gap-5 pb-5 text-center md:w-2/5" dir={direction}>
      {/* Title */}
      <p className="mt-0 mt-4 font-medium text-gray-700">
        {title}
      </p>

      {/* Custom List Brands */}
      <CustomListBrands id={area} />

      {/* Centered Arabic Word */}
      <div className="flex items-center justify-center" style={{marginTop:0}}>
        <h2 className="text-lg font-medium text-black">
        {t("fromText")}
        </h2>
      </div>

      {/* Custom Flags */}
      <CustomFlags
        image={image}
        title={imageTitle}
      />

      {/* Subtitle */}
      <p className="font-medium text-gray-700 " style={{marginTop:0}}>
        {subTitle}
      </p>

      {/* Button */}
        <CustomBlackButton 
        onClick={onClick}
        children={children}
        icon ={Icon}
        />
    </div>
  );
};

export default CustomShoppngCardDetials;
